import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/shape-20.png'
import _imports_1 from '@/assets/images/shape-21.png'


const _hoisted_1 = {
  key: 0,
  class: "page-banner-area bg-secondary"
}
const _hoisted_2 = { class: "container mw-1720" }
const _hoisted_3 = { class: "page-banner-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 list-unstyled bredcrounbs" }
const _hoisted_5 = { class: "container mw-1356" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "products-details-img" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "products-details-content" }
const _hoisted_12 = { class: "ps-0 list-unstyled star d-flex gap-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "product-quantity d-flex" }
const _hoisted_15 = { class: "add-to-cart-counter d-flex justify-content-between align-content-center" }
const _hoisted_16 = { class: "ps-0 mb-0 list-unstyled sku-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/" }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" الرئيسية ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/products" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("المتجر", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.product.name), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.product.image,
                  alt: _ctx.product.name
                }, null, 8, _hoisted_9)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.product.name), 1),
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createElementVNode("li", { key: i }, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "ti ti-star-filled" }, null, -1)
                    ]))])
                  }), 64)),
                  _cache[7] || (_cache[7] = _createElementVNode("li", null, [
                    _createElementVNode("span", null, "5.0")
                  ], -1))
                ]),
                _createElementVNode("h3", null, [
                  (_ctx.product.oldPrice)
                    ? (_openBlock(), _createElementBlock("del", _hoisted_13, _toDisplayString(_ctx.product.oldPrice) + " €", 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.product.price) + " € ", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("input", {
                      type: "button",
                      class: "minusBtn",
                      value: "-",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decreaseQuantity && _ctx.decreaseQuantity(...args)))
                    }),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "count",
                      size: "25",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.quantity) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.quantity]
                    ]),
                    _createElementVNode("input", {
                      type: "button",
                      class: "plusBtn",
                      value: "+",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.increaseQuantity && _ctx.increaseQuantity(...args)))
                    })
                  ]),
                  _createElementVNode("button", {
                    class: "btn ms-4",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addToCartAction && _ctx.addToCartAction(...args)))
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", { class: "border-style" }, "إضافة إلى السلة", -1)
                  ]))])
                ]),
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-secondary" }, "رمز المنتج (SKU):", -1)),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    _createElementVNode("span", null, "IPTV-" + _toDisplayString(_ctx.product.id), 1)
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("li", null, [
                    _createElementVNode("span", { class: "text-secondary" }, "التصنيفات:"),
                    _createTextVNode(),
                    _createElementVNode("span", null, "اشتراكات IPTV")
                  ], -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("li", null, [
                    _createElementVNode("span", { class: "text-secondary" }, "حالة التوفر:"),
                    _createTextVNode(),
                    _createElementVNode("span", { class: "text-grey-teal" }, "متوفر للتفعيل الفوري")
                  ], -1))
                ])
              ])
            ])
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("img", {
          src: _imports_0,
          class: "shape-21 shape",
          alt: "shape"
        }, null, -1)),
        _cache[14] || (_cache[14] = _createElementVNode("img", {
          src: _imports_1,
          class: "shape-22 shape",
          alt: "shape"
        }, null, -1))
      ]))
    : _createCommentVNode("", true)
}